import React from 'react';

interface FeatureToggleExplanationProps {
  text: string;
}

export default function FeatureToggleExplanation({ text }: FeatureToggleExplanationProps) {
  return <p className='text-sm text-subtitle'>{text}</p>;
}
